import React from 'react';
import cn from 'classnames';
import Modal from 'react-modal';
import { getBriefDocs } from '../../../../../design/routes/Workdesk/api/docs.api';
import { downloadAndCompressFiles } from '../../../../../common/utils/ziped_files_downloader';

const SHARE_LINKS_ITEMS = [
  { href: `whatsapp://send?text=${window.location.href}`, iconClassName: 'whats_up_icon' },
  {
    href:
      'mailto:?subject=I wanted you to see this site&amp;body=Check out this site http://www.website.com.',
    iconClassName: 'mail_icon',
  },
  {
    href: '',
    iconClassName: 'share_link_icon',
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href);
    },
  },
  {
    href: '',
    iconClassName: 'download_all_icon',
    onClick: async e => {
      e.stopPropagation();
      e.preventDefault();
      const projId = window.location.pathname.split('/')[2];
      const resp = await getBriefDocs(projId);
      const urlsToDownload = resp.map(item => {
        return { url: item.url, filename: item.filename };
      });
      await downloadAndCompressFiles(urlsToDownload, 'Customer Brief.zip');
    },
  },
];

const shareUrl = (url, token) => {
  return url;
};

const ShareModalComponent = ({
  visible,
  children,
  className,
  contentLabel,
  buttonClose,
  onRequestClose,
  secretLinkToShare,
  ...rest
}) => {
  return (
    <Modal
      isOpen={visible}
      ariaHideApp={false}
      onRequestClose={buttonClose}
      className={cn('share_project_modal', className)}
      {...rest}
    >
      <div className="modal_container">
        {buttonClose && (
          <button type="button" className="modal_close-button" onClick={buttonClose} />
        )}
        <div className="modal_dialog">
          {contentLabel && <h2 className="modal_title">{contentLabel}</h2>}
          {/*<div className="modal_content" dangerouslySetInnerHTML={{ __html: children }} />*/}
          <div className="modal_content">
            <div className="sharemodalTitle">This design is too good to keep to yourself</div>
            <div className="shareModalSubtitle">
              Ready to reveal your masterpiece? Share it with your nearest and dearest, or even that
              nosy neighbour.
            </div>
            <div className="shareModalLinksBlock">
              {SHARE_LINKS_ITEMS.map(({ href, iconClassName, onClick }) => (
                <div
                  key={iconClassName}
                  className={`${iconClassName} shareModalLinksItems`}
                  onClick={onClick}
                >
                  <a href={shareUrl(href, secretLinkToShare)} />
                </div>
              ))}
            </div>
            <div className="shareModalDownTitle">
              Too soon for goodbyes? Book your next room design now and get £50 off or £25 off our
              Styling package.{' '}
            </div>
            <div className="shareModalFooter">
              <button className="footer_button_share">BACK4MORE</button>
              <button className="footer_button_share">STYLEAGAIN25</button>
            </div>

            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareModalComponent;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/ShareButtonModal.js